/**
 * The header Sync button's tooltip (DV-3714): where a sync sends. The PMS when
 * the property syncs with one, webhooks when the account has endpoints, both
 * when both apply. With neither, plain "Sync": the modal says why nothing can
 * be sent.
 */
export const syncButtonTitle = (
  pmsTarget: string | null,
  hasWebhookEndpoints: boolean
): string => {
  if (pmsTarget && hasWebhookEndpoints) return `Sync to ${pmsTarget} and send webhook`;
  if (pmsTarget) return `Sync to ${pmsTarget}`;
  if (hasWebhookEndpoints) return 'Send webhook';
  return 'Sync';
};
